import { memo, useState, useCallback, useEffect, ChangeEvent } from "react";
import { Modal, Form, FormField, FormGroup, Button, Input, Header } from "semantic-ui-react";

// Types
import { BTN_ACTS, PickedState } from "./types/MeBillingType";

export type LinkedCustomerFormData = {
  customer_id: number | string;
  linked_id: string;
};

type ModLinkedCustomerProps = {
  open: boolean;
  onClose: () => void;
  onSave: (data: LinkedCustomerFormData) => void;

  // data
  customerId: number | undefined;
  customerName: string | undefined;

  // common
  languageUX: "en" | "th";
} & Pick<PickedState, "buttonLoadCheck">;

// todo -- ตอนนี้ linked_id เป็น string ต้อง parsed ให้เป็น number

const ModLinkedCustomer = (props: ModLinkedCustomerProps) => {
  const { open, onClose, onSave, customerId, customerName, buttonLoadCheck } = props;

  const [linkedId, setLinkedId] = useState<string>("");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (open) {
      setLinkedId("");
      setError("");
    }
  }, [open]);

  const handleChangeLinkedId = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setLinkedId(e.target.value);

    if (error) {
      setError("");
    }
  }, [error]);

  const validate = (): boolean => {
    if (!linkedId.trim()) {
      setError("กรุณากรอกไอดีผู้ใช้งาน");
      return false;
    }

    return true;
  };

  const handleSubmit = useCallback(() => {
    if (validate()) {
      onSave({
        customer_id: customerId || "",
        linked_id: linkedId.trim(),
      });
    }
  }, [linkedId, customerId, onSave]);

  const handleClose = useCallback(() => {
    setLinkedId("");
    setError("");
    onClose();
  }, [onClose]);

  const labelStyle = {
    minWidth: "140px",
    fontSize: "14px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
  };

  const inputStyle = {
    backgroundColor: "#f5f5f5",
    border: "none",
    borderRadius: "8px",
  };

  return (
    <Modal open={open} onClose={handleClose} size="small">
      <Modal.Content style={{ padding: "2rem" }}>
        {/* Title */}
        <Header
          as="h2"
          textAlign="center"
          style={{
            color: "var(--primary-theme-color)",
            marginBottom: "0.5rem",
          }}
        >
          การเชื่อมหมายเลขผู้รับบริการกับไอดีผู้ใช้งาน
        </Header>

        {/* Subtitle */}
        <p
          style={{
            textAlign: "center",
            color: "#666",
            marginBottom: "2rem",
          }}
        >
          --- กรุณาตรวจสอบข้อมูล และกรอกไอดีผู้ใช้งาน ---
        </p>

        <Form>
          {/* Customer ID (Read-only) */}
          <FormGroup inline>
            <FormField width={5}>
              <label style={labelStyle}>หมายเลขผู้รับบริการ</label>
            </FormField>
            <FormField width={8}>
              <Input
                fluid
                readOnly
                value={customerId || "-"}
                style={{
                  ...inputStyle,
                  maxWidth: "150px",
                }}
                input={{
                  style: {
                    textAlign: "center",
                    backgroundColor: "#f5f5f5",
                    border: "none",
                  },
                }}
              />
            </FormField>
          </FormGroup>

          {/* Customer Name (Read-only) */}
          <FormGroup inline>
            <FormField width={5}>
              <label style={labelStyle}>ชื่อ-สกุล ผู้รับบริการ</label>
            </FormField>
            <FormField width={11}>
              <Input
                fluid
                readOnly
                value={customerName || "-"}
                style={inputStyle}
                input={{
                  style: {
                    backgroundColor: "#f5f5f5",
                    border: "none",
                  },
                }}
              />
            </FormField>
          </FormGroup>

          {/* Linked ID (Editable) */}
          <FormGroup inline>
            <FormField width={5}>
              <label style={labelStyle}>ไอดีผู้ใช้งาน</label>
            </FormField>
            <FormField width={11} error={!!error}>
              <Input
                // todo --- ให้พิมพ์ได้เฉพาะตัวเลขเท่านั้น
                fluid
                placeholder="กรอกข้อมูลที่แสดงบนโทรศัพท์ของผู้รับบริการที่เมนูโปรไฟล์"
                value={linkedId}
                onChange={handleChangeLinkedId}
                style={{
                  borderRadius: "8px",
                }}
              />
              {error && (
                <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                  {error}
                </span>
              )}
            </FormField>
          </FormGroup>
        </Form>

        {/* Action Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            marginTop: "1.5rem",
          }}
        >
          <Button
            onClick={handleClose}
            style={{
              backgroundColor: "#4a4a4a",
              color: "white",
              minWidth: "120px",
              borderRadius: "8px",
            }}
          >
            ปิดหน้าต่าง
          </Button>
          <Button
            onClick={handleSubmit}
            loading={!!buttonLoadCheck?.[BTN_ACTS.LINK_CUSTOMER]}
            style={{
              backgroundColor: "var(--primary-theme-color)",
              color: "white",
              minWidth: "120px",
              borderRadius: "8px",
            }}
          >
            บันทึกข้อมูล
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  );
};

ModLinkedCustomer.displayName = "ModLinkedCustomer";

export default memo(ModLinkedCustomer);